import React from 'react'
import clsx from 'clsx'

interface CardProps {
  title?: string
  action?: React.ReactNode
  className?: string
  children: React.ReactNode
}

export default function Card({ title, action, className, children }: CardProps) {
  return (
    <div className={clsx('card', className)}>
      {(title || action) && (
        <div className="card-header flex items-center justify-between">
          <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
          {action}
        </div>
      )}
      <div className="card-body">{children}</div>
    </div>
  )
}
